import "../../css/element/Button.css"

/**
 * props.label: 버튼에 표시될 텍스트
 * props.onClick: 클릭 시 callback
 * props.id: 버튼 div에 전달할 id
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
let BigButton = (props) => {
    return (<div className="button big-button" id={typeof props.id === "undefined" ? null:props.id} onClick={(e) => props.onClick(e)}>
        <p className="big-button-text">
            <span className="plus">+</span>
            {props.label}
        </p>
    </div>)
}
let SmallButton = (props) => {
    return (<div className="button small-button" id={typeof props.id === "undefined" ? null:props.id} onClick={(e)=>props.onClick(e)}>
        <p className={"small-button-text"}>
            {props.label}
        </p>
    </div> )
}
export {BigButton, SmallButton};